import angular, { IScope, ITimeoutService } from 'angular';
import uiRouter, { StateService } from '@uirouter/angularjs';
import { TODO, UIBModalService } from '@b2b/types/core';
import { ApiService } from '@b2b/common/services/api/types';
import moment from 'moment';

TemplatesCreateSchedulesCreateTimesController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$uibModal',
  'ApiService',
  'HelpersService',
  'TemplatesService',
  'CalendarService',
  'ValidateService',
  'WizardFactory',
  'UserPreferencesService',
];

function TemplatesCreateSchedulesCreateTimesController(
  $scope: IScope & { templatesCreateSchedulesCreateTimes: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  $uibModal: UIBModalService,
  ApiService: ApiService,
  HelpersService: TODO,
  TemplatesService: TODO,
  CalendarService: TODO,
  ValidateService: TODO,
  WizardFactory: TODO,
  UserPreferencesService: TODO
) {
  const ctrl = {
    model: {} as TODO,
    calendar: {} as TODO,
    showModal: {} as TODO,
    exceptionsCache: {} as TODO,
    wizard: {} as TODO,
    scheduleRangeHours: [] as TODO[],

    type: 'standard',

    showWeekdays: false,
    noExceptions: false,
    hasEndTimeException: false as boolean | string,
    hasStartTimeException: false as boolean | string,
    allowEditExceptions: false,
    startTime: new Date(),
    endTime: new Date(),
    getEth: HelpersService.getEth,
    dateFormats: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
    hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
    repeatTypes: TemplatesService.repeatTypes,
    repeatMonthTypes: TemplatesService.repeatMonthTypes,
    getRepeatMonthType: TemplatesService.getRepeatMonthType,
    scheduleHours: [] as TODO[],
    scheduleRepeatMonthType: 'date',
    repeatMonthType: {} as TODO,
    repeatFrequency: {} as TODO,
    repeatDays: {
      Su: false,
      M: false,
      Tu: false,
      W: false,
      Th: false,
      F: false,
      Sa: false,
    },

    scheduleRangeValidators: [] as TODO[],

    scheduleEndTime: null as TODO,
    isRepeating: false,

    init: function () {
      var i, ii;

      if ($state.params && $state.params.scheduleId) {
        ctrl.model = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
      } else {
        ctrl.model = TemplatesService.getNewSchedule().schedule;
      }
      ctrl.initWizard();
      ctrl.getCalendar();
      ValidateService.addFieldTests(ctrl.wizard.getStep('times').validators);

      if (
        ($state.params && $state.params.type && $state.params.type === 'private') ||
        (ctrl.model && ctrl.model.type === 'private')
      ) {
        ctrl.type = 'private';
      }

      if (ctrl.model) {
        ctrl.repeatFrequency = TemplatesService.getScheduleRepeatCycle(ctrl.model);
        ctrl.repeatMonthType = ctrl.getScheduleRepeatMonthType();
        ctrl.scheduleHours = TemplatesService.getScheduleHours(ctrl.model);
        ctrl.scheduleRangeHours = TemplatesService.getScheduleRangeHours(ctrl.model);
        // Set warning for ranges
        for (i = 0, ii = ctrl.scheduleRangeHours.length; i < ii; i++) {
          ctrl.scheduleRangeHours[i].warning = false;
        }

        if (ctrl.model.effectiveStartTime) {
          ctrl.startTime = CalendarService.parseDate(ctrl.model.effectiveStartTime);
        }

        if (ctrl.model.effectiveEndTime) {
          ctrl.endTime = CalendarService.parseDate(ctrl.model.effectiveEndTime);
        } else {
          const currentTemplate = TemplatesService.getModel();
          const lastPublished = currentTemplate?.lastPublished || undefined;
          ctrl.endTime = moment(lastPublished).add(1,'years').toDate()
        }

        if (!ctrl.model.hasOwnProperty('honorHolidays')) {
          ctrl.model.honorHolidays = false;
        }

        if (!ctrl.model.hasOwnProperty('honorOpenHours')) {
          ctrl.model.honorOpenHours = false;
        }

        ctrl.model.salesChannels = TemplatesService.orderSalesChannels(ctrl.model.salesChannels);

        ctrl.setRepeatDays(ctrl.model.weekdays);
        $timeout(function () {
          ctrl.setRepeating();
        }, 0);
        ctrl.updateScheduleRangeValidators();
      } else {
        if ($state.params && $state.params.scheduleId) {
          // No schedule exists but was referenced
          $scope.$emit('TemplatesCreateSchedulesCreateController::Error', {
            message: 'Schedule does not exist',
            callback: function () {
              window.history.go(-1);
            },
          });
        } else {
          // Should never occur but in case they arrive at this state manually we will throw a message
          $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: 'Schedule could not be created' });
        }
      }

      $scope.$on('TemplatesCreateSchedulesCreateController::Save', ctrl.onTemplatesCreateSchedulesCreateControllerSave);

      $scope.$on(
        '$destroy',
        $scope.$watchCollection('templatesCreateSchedulesCreateTimes.repeatDays', ctrl.onRepeatDaysUpdate)
      );

      // Trigger $watch
      if (!ctrl.model.honorHolidays && !ctrl.model.honorOpenHours) {
        ctrl.noExceptions = true;
      }

      // Next tick
      $timeout(function () {
        ctrl.checkExceptions();
      }, 0);

      console.log('TemplatesCreateSchedulesCreateTimesController::init');
    },

    isStandard: function () {
      return ctrl.type === 'standard';
    },

    initWizard: function () {
      ctrl.wizard = new WizardFactory();
      ctrl.wizard.init({
        name: 'times',
        validators: [
          {
            field: 'templates-create-schedules-create-times-capacity-min',
            greater: {
              message: 'A capacity of 0 or greater is required',
              test: function () {
                return {
                  greater: parseInt(ctrl.model.capacity, 10),
                  less: -1,
                };
              },
            },
          },
          {
            field: 'templates-create-schedules-create-times-duration-hr-min',
            greater: {
              message: 'Please enter valid duration hour',
              test: function () {
                var greater = parseInt(ctrl.model.duration.hour, 10);
                if (ctrl.isAdmissionType('generalAdmission')) {
                  greater = 1;
                }
                return {
                  greater: greater,
                  less: -1,
                };
              },
            },
          },
          {
            field: 'templates-create-schedules-create-times-duration-m-min',
            greater: {
              message: 'Please enter valid duration minutes',
              test: function () {
                var greater = parseInt(ctrl.model.duration.hour, 10);
                if (ctrl.isAdmissionType('generalAdmission')) {
                  greater = 0;
                }
                return {
                  greater: greater,
                  less: -1,
                };
              },
            },
          },
          {
            field: 'templates-create-schedules-create-times-duration-total',
            greater: {
              message: 'Events must be 1 minute or longer',
              test: function () {
                return {
                  greater: parseInt(ctrl.model.duration.hour, 10) + parseInt(ctrl.model.duration.minutes, 10),
                  less: 0,
                };
              },
            },
          },
          {
            field: 'templates-create-schedules-create-times-ends',
            greater: {
              message: 'End date cannot be sooner than start date',
              test: function () {
                let r: { greater: number; less: number; equalTo?: boolean } = {
                  greater: 1,
                  less: 0,
                };

                if (ctrl.repeatFrequency.value === 'never') {
                  r = {
                    greater: 1,
                    less: 0,
                    equalTo: true,
                  };
                } else {
                  r = {
                    greater: ctrl.endTime?.getTime() || 0,
                    less: ctrl.startTime?.getTime() || 0,
                    equalTo: true,
                  };
                }

                return r;
              },
            },
          },
        ],
      });
    },

    getCalendar: function () {
      ApiService.tenant.calendar.detail().then(ctrl.success.getCalendar, ctrl.error.getCalendar);
    },

    honorOpenHours: function () {
      return ctrl.model.honorOpenHours && ctrl.calendar.all instanceof Array;
    },

    showOpenHours: function () {
      ctrl.showModal = $uibModal.open({
        templateUrl: 'views/application/views/templates/create/schedules/modals/openingHours.tpl.html',
        size: 'md',
        controller: 'TemplatesCreateSchedulesOpeningHoursModalController',
        resolve: {
          openHours: function () {
            return ctrl.calendar.open;
          },
          closedHours: function () {
            return ctrl.calendar.closed;
          },
          hourFormat: function () {
            return ctrl.hourFormat;
          },
        },
      });
      // Invoked when modal completes with close(params)
      ctrl.showModal.result.then(
        function () {
          // Do nothing
        },
        function () {
          // Do nothing
        }
      );
    },

    hasCalendarExceptions: function (ISODate) {
      let r: string | boolean = false;

      if (ctrl.model.honorHolidays) {
        if (ctrl.calendar.exceptions instanceof Array) {
          for (let i = 0, ii = ctrl.calendar.exceptions.length; i < ii; i++) {
            if (ctrl.calendar.exceptions[i].date === ISODate && ctrl.calendar.exceptions[i].hours instanceof Array) {
              if (ctrl.calendar.exceptions[i].hours[0] === 'closed') {
                r = 'Closed all day';
                break;
              } else if (ctrl.calendar.exceptions[i].hours[0]) {
                r = 'Open ' + CalendarService.rangeToTime(ctrl.calendar.exceptions[i].hours[0]);
              }
            }
          }
        }
      }
      return r;
    },

    showExceptions: function () {
      ctrl.showModal = $uibModal.open({
        templateUrl: 'views/application/views/templates/create/schedules/modals/holidaysExceptions.tpl.html',
        size: 'md',
        controller: 'TemplatesCreateSchedulesHolidaysExceptionsModalController',
        resolve: {
          exceptions: function () {
            return ctrl.calendar.exceptions;
          },
        },
      });
      // Invoked when modal completes with close(params)
      ctrl.showModal.result.then(
        function () {
          // Do nothing
        },
        function () {
          // Do nothing
        }
      );
    },

    updateScheduleRangeValidators: function () {
      var i, ii;

      for (i = 0, ii = ctrl.scheduleRangeHours.length; i < ii; i++) {
        ctrl.addScheduleRangeValidator(i);
      }
    },

    clearScheduleRangeValidators: function () {
      for (let i = 0, ii = ctrl.scheduleRangeValidators.length; i < ii; i++) {
        ctrl.wizard.removeValidator('times', 'templates-create-schedules-create-times-range-' + i);
        ValidateService.removeFieldTest({ field: 'templates-create-schedules-create-times-range-' + i });
        ctrl.scheduleRangeValidators.splice(i, 1);
      }

      ctrl.scheduleRangeValidators = [];
    },

    addScheduleRangeValidator: function (index) {
      const test = {
        field: 'templates-create-schedules-create-times-range-' + index,
        greater: {
          message: 'Hours cannot end before they begin',
          test: function () {
            return {
              greater: ctrl.scheduleRangeHours[index].end.getTime(),
              less: ctrl.scheduleRangeHours[index].start.getTime(),
            };
          },
        },
      };

      ctrl.scheduleRangeValidators.push(test);

      ctrl.wizard.addValidator('times', ctrl.scheduleRangeValidators[ctrl.scheduleRangeValidators.length - 1]);

      ValidateService.addFieldTest(ctrl.scheduleRangeValidators[ctrl.scheduleRangeValidators.length - 1]);
    },

    isAdmissionType: function (type) {
      return TemplatesService.isAdmissionType(type);
    },

    addHour: function (index, fieldId) {
      ctrl.model.hours.push(TemplatesService.createHour());
      ctrl.scheduleHours.push(TemplatesService.hourToDate(ctrl.model.hours[ctrl.model.hours.length - 1]));
      // next tick
      $timeout(function () {
        ctrl.setInputFocus(ctrl.scheduleHours.length - 1, fieldId);
      }, 0);
    },

    removeHour: function (index, fieldId) {
      ctrl.model.hours.splice(index, 1);
      ctrl.scheduleHours.splice(index, 1);
      // next tick
      $timeout(function () {
        ctrl.setInputFocus(index - 1, fieldId);
      }, 0);
    },

    addRange: function (index, fieldId) {
      if (!ctrl.model.ranges) {
        ctrl.model.ranges = [];
      }
      ctrl.model.ranges.push(TemplatesService.createRange());
      ctrl.scheduleRangeHours.push({
        end: TemplatesService.hourToDate(ctrl.model.ranges[ctrl.model.ranges.length - 1].end),
        start: TemplatesService.hourToDate(ctrl.model.ranges[ctrl.model.ranges.length - 1].start),
      });

      ctrl.addScheduleRangeValidator(ctrl.scheduleRangeHours.length - 1);
      // next tick
      $timeout(function () {
        ctrl.setInputFocus(ctrl.scheduleRangeHours.length - 1, fieldId);
      }, 0);
    },

    removeRange: function (index, fieldId) {
      ctrl.model.ranges.splice(index, 1);
      ctrl.scheduleRangeHours.splice(index, 1);
      // next tick
      $timeout(function () {
        // Need to reset the range validators because of old index references
        ctrl.clearScheduleRangeValidators();
        ctrl.updateScheduleRangeValidators();
        // Revalidate to clear old errors
        ctrl.wizard.validate();

        ctrl.setInputFocus(index - 1, fieldId);
      }, 0);
    },

    setInputFocus: function (index, fieldId) {
      const el: TODO = $('#' + fieldId + '-' + (index || 0));
      if (el.length && el.find('input').length) {
        el.find('input').get(0).focus();
      }
    },

    rangeToTime: function (range) {
      return CalendarService.rangeToTime(range);
    },

    updateScheduleHours: function (index) {
      var d;

      if (ctrl.model.hours[index]) {
        d = new Date(ctrl.scheduleHours[index]);
        ctrl.model.hours[index].hour = parseInt(d.getHours(), 10);
        ctrl.model.hours[index].minutes = parseInt(d.getMinutes(), 10);
      }
    },

    updateScheduleRangeHours: function (index) {
      var ds, de;

      if (ctrl.model.ranges[index]) {
        ds = new Date(ctrl.scheduleRangeHours[index].start);
        de = new Date(ctrl.scheduleRangeHours[index].end);
        ctrl.model.ranges[index].start.hour = parseInt(ds.getHours(), 10);
        ctrl.model.ranges[index].start.minutes = parseInt(ds.getMinutes(), 10);
        ctrl.model.ranges[index].end.hour = parseInt(de.getHours(), 10);
        ctrl.model.ranges[index].end.minutes = parseInt(de.getMinutes(), 10);
      }
    },

    getScheduleRepeatMonthType: function () {
      var i,
        ii,
        r = ctrl.repeatMonthTypes[0];

      for (i = 0, ii = ctrl.repeatMonthTypes.length; i < ii; i++) {
        if (ctrl.model.repeatMonthType === ctrl.repeatMonthTypes[i].value) {
          r = ctrl.repeatMonthTypes[i];
          break;
        }
      }

      return r;
    },

    setRepeating: function () {
      console.log(
        'setRepeating',
        ctrl.repeatFrequency.value,
        ctrl.scheduleEndTime,
        ctrl.model.effectiveEndTime
      );
      ctrl.isRepeating = ctrl.repeatFrequency.value && ctrl.repeatFrequency.value !== 'never';
      ctrl.model.repeatCycle = ctrl.repeatFrequency.value;

      if (ctrl.model.repeatCycle === 'day') {
        ctrl.showWeekdays = false;
      } else if (ctrl.model.repeatCycle === 'week') {
        ctrl.showWeekdays = true;
      } else if (ctrl.model.repeatCycle === 'month') {
        if (ctrl.model.monthly instanceof Array && ctrl.model.monthly.length > 0) {
          ctrl.repeatMonthType = ctrl.getRepeatMonthType(ctrl.model.monthly[0]);
          ctrl.showWeekdays = true;
        } else if (ctrl.model.daysOfMonth instanceof Array && ctrl.model.daysOfMonth.length > 0) {
          ctrl.repeatMonthType = ctrl.getRepeatMonthType('date');
          ctrl.showWeekdays = false;
        }
      }
    },

    setRepeatDays: function (days) {
      var i, ii, day, isClosed;

      if (days instanceof Array) {
        for (day in ctrl.repeatDays) {
          if (ctrl.repeatDays.hasOwnProperty(day)) {
            if (ctrl.honorOpenHours()) {
              isClosed = false;
              for (i = 0, ii = ctrl.calendar.closed.length; i < ii; i++) {
                if (ctrl.calendar.closed[i].day.match(new RegExp('^' + day))) {
                  isClosed = true;
                  break;
                }
              }
              ctrl.repeatDays[day] = days.indexOf(day) !== -1 && !isClosed;
            } else {
              ctrl.repeatDays[day] = days.indexOf(day) !== -1;
            }
          } else {
            ctrl.repeatDays[day] = false;
          }
        }
      }
    },

    getRepeatDays: function () {
      const days: string[] = [];

      for (const day in ctrl.repeatDays) {
        if (ctrl.repeatDays.hasOwnProperty(day) && ctrl.repeatDays[day] === true) {
          days.push(day);
        }
      }
      return days;
    },

    isRepeatCycle: function (cycle) {
      return ctrl.repeatFrequency.value === cycle;
    },

    isRepeatMonthType: function (type) {
      return ctrl.repeatMonthType.value === type;
    },

    isRepeatDaySelected: function (day) {
      return ctrl.repeatDays[day];
    },

    addDayOfMonth: function (index, fieldId) {
      ctrl.model.daysOfMonth.push(1);
      // next tick
      $timeout(function () {
        ctrl.setInputFocus(ctrl.model.daysOfMonth.length - 1, fieldId);
      }, 0);
    },

    removeDayOfMonth: function (index, fieldId) {
      ctrl.model.daysOfMonth.splice(index, 1);
      // next tick
      $timeout(function () {
        ctrl.setInputFocus(index - 1, fieldId);
      }, 0);
    },

    checkRepeat: function () {
      var showWeekdays = false,
        sDate;

      if (ctrl.isRepeatCycle('day')) {
        ctrl.model.weekdays = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
        ctrl.model.daysOfMonth = null;
        ctrl.model.monthly = null;
      } else if (ctrl.isRepeatCycle('week')) {
        ctrl.model.monthly = null;
        ctrl.model.daysOfMonth = null;
        showWeekdays = true;
      } else if (ctrl.isRepeatCycle('month') && ctrl.repeatMonthType.value !== 'date') {
        ctrl.model.monthly = [ctrl.repeatMonthType.value];
        ctrl.model.daysOfMonth = null;
        showWeekdays = true;
      } else {
        if (!ctrl.startTime.hasOwnProperty('getDate')) {
          sDate = new Date(ctrl.startTime);
        }
        ctrl.endTime = ctrl.startTime;
        ctrl.model.monthly = null;
        if (!(ctrl.model.daysOfMonth instanceof Array && ctrl.model.length > 0)) {
          ctrl.model.daysOfMonth = [1];
        }
        ctrl.model.weekdays = [];
      }

      ctrl.showWeekdays = showWeekdays;

      ctrl.setRepeating();
    },

    checkExceptions: function () {
      if (!ctrl.model.honorHolidays && !ctrl.model.honorOpenHours) {
        ctrl.noExceptions = true;
      } else {
        ctrl.noExceptions = false;
      }

      ctrl.hasStartTimeException = ctrl.hasCalendarExceptions(CalendarService.toISO8601(ctrl.startTime).split('T')[0]);
      ctrl.hasEndTimeException = ctrl.hasCalendarExceptions(CalendarService.toISO8601(ctrl.endTime).split('T')[0]);
      //ctrl.setRepeatDays(ctrl.model.weekdays);
      ctrl.checkClosedDays(ctrl.repeatDays);
      ctrl.checkOpeningHours();
    },

    checkClosedDays: function (days) {
      var i, ii, day;

      if (ctrl.calendar && ctrl.calendar.closed instanceof Array) {
        if (days) {
          for (i = 0, ii = ctrl.calendar.closed.length; i < ii; i++) {
            ctrl.calendar.closed[i].warning = false;

            for (day in days) {
              if (days[day] && CalendarService.weekdays[day].name === ctrl.calendar.closed[i].day) {
                ctrl.calendar.closed[i].warning = true;
                break;
              }
            }
          }
        }
      }
    },

    checkOpeningHours: function () {
      var i,
        ii,
        j,
        jj,
        k,
        kk,
        openEnd,
        hoursEnd,
        rangeStart,
        rangeStartHour,
        rangeStartMinute,
        rangeStartMeridian,
        rangeHoursStartHour;

      if (ctrl.calendar && ctrl.calendar.open instanceof Array) {
        outer: for (i = 0, ii = ctrl.calendar.open.length; i < ii; i++) {
          for (j = 0, jj = ctrl.scheduleRangeHours.length; j < jj; j++) {
            // Get range start time
            ctrl.scheduleRangeHours[j].warning = false;

            if (ctrl.isRepeatDaySelected(CalendarService.getWeekdayShortName(ctrl.calendar.open[i].day))) {
              if (ctrl.model.honorOpenHours) {
                rangeStart = CalendarService.toISO8601(ctrl.scheduleRangeHours[j].start).split('T')[1];

                rangeStartHour = CalendarService.toHour(+rangeStart.split(':')[0]);
                rangeStartMinute = CalendarService.toMinutes(+rangeStart.split(':')[1]);
                rangeStartMeridian = CalendarService.getMeridian(+rangeStart.split(':')[0]);

                rangeHoursStartHour = CalendarService.timeToDate(
                  rangeStartHour + ':' + rangeStartMinute + ' ' + rangeStartMeridian
                );
                for (k = 0, kk = ctrl.calendar.open[i].hours.length; k < kk; k++) {
                  // Get open hours end time
                  hoursEnd = ctrl.calendar.open[i].hours[k].split(' to ')[1];
                  openEnd = CalendarService.timeToDate(hoursEnd);
                  if (rangeHoursStartHour.getTime() >= openEnd.getTime()) {
                    ctrl.scheduleRangeHours[j].warning =
                      ctrl.calendar.open[i].day + ' hours: ' + ctrl.calendar.open[i].hours[k];
                    break outer;
                  }
                }
              }
            }
          }
        }
      }
    },

    editExceptions: function () {
      ctrl.exceptionsCache.honorOpenHours = ctrl.model.honorOpenHours;
      ctrl.exceptionsCache.honorHolidays = ctrl.model.honorHolidays;
      ctrl.checkExceptions();
      ctrl.allowEditExceptions = true;
    },

    saveExceptions: function () {
      ctrl.exceptionsCache.honorOpenHours = ctrl.model.honorOpenHours;
      ctrl.exceptionsCache.honorHolidays = ctrl.model.honorHolidays;
      ctrl.checkExceptions();
      ctrl.allowEditExceptions = false;
    },

    cancelExceptions: function () {
      ctrl.model.honorOpenHours = ctrl.exceptionsCache.honorOpenHours;
      ctrl.model.honorHolidays = ctrl.exceptionsCache.honorHolidays;
      ctrl.checkExceptions();
      ctrl.allowEditExceptions = false;
    },

    processCalendar: function (calendar) {
      let all: Record<string, any> = {},
        open: Record<string, any> = {},
        closed: Record<string, any> = {};

      const weekdays = CalendarService.getWeekdayArray();

      if (calendar.standard instanceof Array && calendar.standard.length) {
        // Add delta of closed and open hours
        calendar.all = [];
        calendar.open = [];
        calendar.closed = [];

        for (let j = 0, jj = weekdays.length; j < jj; j++) {
          for (let i = 0, ii = calendar.standard.length; i < ii; i++) {
            all = {};
            open = {};
            closed = {};

            // We only save one day per object so no need to iterate for now
            if (
              calendar.standard[i].weekdays instanceof Array &&
              calendar.standard[i].weekdays.length &&
              weekdays[j] === calendar.standard[i].weekdays[0]
            ) {
              all.day = calendar.standard[i].weekdays[0];
              open.day = calendar.standard[i].weekdays[0];

              if (calendar.standard[i].hours instanceof Array && calendar.standard[i].hours.length) {
                all.hours = [];
                open.hours = [];
                for (let k = 0, kk = calendar.standard[i].hours.length; k < kk; k++) {
                  all.hours.push(
                    CalendarService.rangeToTime(calendar.standard[i].hours[k]),
                    UserPreferencesService.hasPreferences('standardTime')
                  );
                  open.hours.push(CalendarService.rangeToTime(calendar.standard[i].hours[k]));
                }
              }
              break;
            } else {
              all.day = weekdays[j];
              all.hours = ['Closed'];
              closed.day = weekdays[j];
              closed.hours = ['Closed'];
            }
          }

          calendar.all.push(all);

          if (open.hours instanceof Array) {
            calendar.open.push(open);
          }

          if (closed.hours instanceof Array) {
            calendar.closed.push(closed);
          }
        }
      }

      return calendar;
    },

    success: {
      init: function (response) {
        // noop
      },
      getCalendar: function (response) {
        ctrl.calendar = ctrl.processCalendar(response.data.payload);
        if (ctrl.calendar.exceptions instanceof Array || ctrl.calendar.standard instanceof Array) {
          $scope.$on(
            '$destroy',
            $scope.$watch('templatesCreateSchedulesCreateTimes.startTime', ctrl.onStartTimeUpdate)
          );
          $scope.$on('$destroy', $scope.$watch('templatesCreateSchedulesCreateTimes.endTime', ctrl.onEndTimeUpdate));
        }
      },
    },

    error: {
      init: function (response) {
        // noop
      },
      getCalendar: function (response) {
        // noop
      },
    },

    onTemplatesCreateSchedulesCreateControllerSave: function () {
      ctrl.model.effectiveStartTime = CalendarService.toISO8601(ctrl.startTime);
      ctrl.model.repeatCycle = ctrl.repeatFrequency.value;

      if (ctrl.model.repeatCycle === 'never' && ctrl.startTime) {
        ctrl.endTime = new Date(
          ctrl.startTime.getFullYear(),
          ctrl.startTime.getMonth(),
          ctrl.startTime.getDate(),
          23,
          59,
          59
        );
      } else if (ctrl.endTime) {
        ctrl.endTime = new Date(
          ctrl.endTime.getFullYear(),
          ctrl.endTime.getMonth(),
          ctrl.endTime.getDate(),
          23,
          59,
          59
        );
      }
      ctrl.model.effectiveEndTime = CalendarService.toISO8601(ctrl.endTime);

      // Only assign weekdays when visible
      if (ctrl.showWeekdays) {
        ctrl.model.weekdays = ctrl.getRepeatDays();
      }

      TemplatesService.setSchedule(ctrl.model);
      TemplatesService.verifySchedules();

      ctrl.wizard.validate();
    },

    onRepeatDaysUpdate: function (n, o) {
      ctrl.checkClosedDays(n);
      ctrl.checkOpeningHours();
    },

    onStartTimeUpdate: function (n, o) {
      const date = CalendarService.toISO8601(n);
      ctrl.hasStartTimeException = date && ctrl.hasCalendarExceptions(date.split('T')[0]);
    },

    onEndTimeUpdate: function (n, o) {
      const date = CalendarService.toISO8601(n);
      ctrl.hasEndTimeException = date && ctrl.hasCalendarExceptions(date.split('T')[0]);
    },
  };

  $scope.templatesCreateSchedulesCreateTimes = ctrl;
  ctrl.init();
}

export const TemplatesCreateSchedulesCreateTimesControllerModule = angular
  .module('acme.view.application.templates.create.schedules.create.times.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.templates',
    'acme.common.service.validate',
    'acme.common.service.userPreferences',
    'acme.common.factory.wizard',
    'acme.view.application.templates.create.schedules.openingHours.controllers',
    'acme.view.application.templates.create.schedules.holidaysExceptions.controllers',
  ])

  .controller('TemplatesCreateSchedulesCreateTimesController', TemplatesCreateSchedulesCreateTimesController).name;
